import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import { CalculationComponent } from './calculation.component';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { CalculationService } from './calculation.service';

@NgModule({
  declarations: [
    CalculationComponent
  ],
  exports: [
  ],
  imports: [
    SharedModule,
    BsDatepickerModule,
  ],
  providers: [
    CalculationService,
  ]
})
export class CalculationModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/calculation/calculation.module.ts